/* =========================================================================
   Brain2Canvas — Case-Detail v2: das einzige eigene Skript der Seite.
   Zwei Aufgaben, sonst nichts:
     1. Reveal — Startzustand wird HIER per JS gesetzt (Klasse js-reveal),
        damit ohne JS oder bei Observer-Fehler der volle Endzustand steht
        (DOSSIER CB.5 Regel 2, Fehlerbild "weiss auf weiss" in produkt.html).
        F-044-Nachtrag (05.08.2026, SEV1 Case-v2 below-fold-Regression):
        zwei Fallback-Netze wie assets/b2c-muc-hub.js — 1,5s (kein Element
        hat .in => alles zeigen) und ein HARTES 5s-Netz, das ALLE
        .b2c-reveal unbedingt zeigt, unabhaengig von der aktuellen
        Scroll-Position. Der alte Fallback zeigte nur, was GENAU 3s nach
        Seitenaufruf zufaellig im Sichtfeld stand — below-fold-Sektionen,
        die der IntersectionObserver aus irgendeinem Grund nie feuerte
        (Crawler/Tab-Visibility-Edgecases, blockierte Extensions, alte
        Browser), blieben dauerhaft unsichtbar. "Nie permanent unsichtbar"
        gilt jetzt unbedingt.
     2. Mobile-Navigation aus der vorhandenen <nav> (Hamburger + Drawer).
   Kein Scroll-Listener (STYLE-KIT §0 / DOSSIER CB.5 Regel 1) — die einzige
   scrollgebundene Bewegung ist die Fortschrittsleiste, und die laeuft
   deklarativ ueber animation-timeline in der CSS.
   ========================================================================= */
(function () {
  var root = document.getElementById('b2c-case');
  if (!root) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- Reveal */
  function reveal() {
    var els = Array.prototype.slice.call(root.querySelectorAll('.b2c-reveal'));  /* F-xxx 08.08.2026: war eine NodeList — die kennt forEach, aber kein some(), deshalb warf das 1,5s-Sicherheitsnetz und .b2c-reveal blieb unsichtbar, wenn der IntersectionObserver nicht auslöste. */
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;   /* Endzustand bleibt */
    root.classList.add('js-reveal');
    function revealAll() {
      els.forEach(function (el) { el.classList.add('in'); });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
    /* Netz 1 — Observer erkennbar kaputt: nach 1,5 s hat NICHTS ausgeloest,
       obwohl beim Laden immer Elemente im Sichtfeld stehen. Dann alles zeigen. */
    setTimeout(function () {
      var seen = els.some(function (el) { return el.classList.contains('in'); });
      if (!seen) revealAll();
    }, 1500);
    /* Netz 2 — bedingungsloser Ausstieg. Was nach 5 s noch versteckt ist
       (auch below-fold, egal ob je gescrollt wurde), wird gezeigt.
       Sichtbarkeit schlaegt Effekt (F-044). */
    setTimeout(revealAll, 5000);
  }

  /* --------------------------------------------------------- Mobile-Nav */
  function mobilenav() {
    var hdr = root.querySelector('.b2c-hdr');
    var hdrIn = hdr && hdr.querySelector('.b2c-hdr-in');
    var nav = hdrIn && hdrIn.querySelector('.b2c-nav');
    if (!hdrIn || !nav || hdrIn.querySelector('.b2c-hamb')) return;
    var links = [].slice.call(nav.querySelectorAll('a'));
    if (!links.length) return;

    var hamb = document.createElement('button');
    hamb.className = 'b2c-hamb';
    hamb.type = 'button';
    hamb.setAttribute('aria-label', 'Menü öffnen');
    hamb.setAttribute('aria-expanded', 'false');
    hamb.setAttribute('aria-controls', 'b2c-mnav');
    hamb.innerHTML = '<span></span><span></span><span></span>';
    hdrIn.appendChild(hamb);

    var mnav = document.createElement('nav');
    mnav.className = 'b2c-mnav';
    mnav.id = 'b2c-mnav';
    mnav.setAttribute('aria-label', 'Mobile Navigation');
    links.forEach(function (a) { mnav.appendChild(a.cloneNode(true)); });
    var cta = hdrIn.querySelector('.b2c-btn');
    if (cta) {
      var c = document.createElement('a');
      c.href = cta.getAttribute('href') || '#';
      c.textContent = (cta.textContent || 'Anfragen').trim();
      c.className = 'b2c-mnav-cta';
      mnav.appendChild(c);
    }
    hdr.appendChild(mnav);

    function setOpen(open) {
      mnav.classList.toggle('open', open);
      hamb.setAttribute('aria-expanded', open ? 'true' : 'false');
      hamb.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    hamb.addEventListener('click', function () { setOpen(!mnav.classList.contains('open')); });
    mnav.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    addEventListener('resize', function () { if (innerWidth >= 900) setOpen(false); }, { passive: true });
  }

  function boot() { reveal(); mobilenav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
